import { Component, OnInit } from '@angular/core';
import {NetworkMonitorService} from "ngx-network-monitor";

@Component({
  selector: 'app-network-indicator',
  templateUrl: './network-indicator.component.html',
  styleUrls: ['./network-indicator.component.css']
})
export class NetworkIndicatorComponent implements OnInit {

  networkConnection: 'ONLINE' | 'SLOW' | 'OFFLINE' = 'ONLINE';

  constructor(private networkMonitor: NetworkMonitorService){}

  ngOnInit(): void {
    this.networkMonitor.networkStatus$.subscribe(status => {
      if (!(status.online)) {
        this.networkConnection = 'OFFLINE'
      } else if (status.poorConnection) {
        this.networkConnection = 'SLOW'
      } else {
        this.networkConnection = 'ONLINE'
      }
    });
  }
}
